import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardBody,
} from "reactstrap";
import classnames from "classnames";
import api from "../../api";

import PromoQueue from "../../components/Admin/PromoQueue";
import AdminDashboard from "../../components/Admin/AdminDashboard";
import AdminLogs from "../../components/Admin/AdminLogs";
import RateListManagement from "../../components/Admin/RateListManagement";

const AdminPanel = () => {
  document.title = "Pokemon Radiance | Admin Panel";
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("main");
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if the user is an admin
    const checkAdminStatus = async () => {
      try {
        const response = await api.get("/v1/admin/rank", {
          headers: { Accept: "application/json" },
          withCredentials: true,
        });

        if (response.data.length > 0 && response.data[0].adm === 1) {
          setIsAdmin(true);
        } else {
          navigate("/dashboard");
        }
      } catch (error) {
        console.error("Failed to check admin status:", error);
        navigate("/dashboard");
      } finally {
        setLoading(false);
      }
    };

    checkAdminStatus();
  }, [navigate]);

  if (loading) return <p>Loading...</p>;

  return (
    <Container
      fluid
      style={{
        marginTop: "80px", // Push down from header
        paddingTop: "20px", // Extra space for cleaner UI
      }}
    >
      {/* Navigation Tabs */}
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "main" })}
            onClick={() => setActiveTab("main")}
            style={{ cursor: "pointer" }}
          >
            Main
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "queuePromo" })}
            onClick={() => setActiveTab("queuePromo")}
            style={{ cursor: "pointer" }}
          >
            Queue Promo
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "gameStats" })}
            onClick={() => setActiveTab("gameStats")}
            style={{ cursor: "pointer" }}
          >
            Game Statistics
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "logs" })}
            onClick={() => setActiveTab("logs")}
            style={{ cursor: "pointer" }}
          >
            Logs
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "ratelist" })}
            onClick={() => setActiveTab("ratelist")}
            style={{ cursor: "pointer" }}
          >
            RateList Management
          </NavLink>
        </NavItem>
      </Nav>

      {/* Tab Content */}
      <TabContent activeTab={activeTab} className="mt-3">
        <TabPane tabId="main">
          <Card>
            <CardBody>
              <AdminDashboard />
            </CardBody>
          </Card>
        </TabPane>
        <TabPane tabId="queuePromo">
          <Card>
            <CardBody>
              <h4>Queue Promo</h4>
              <TabPane tabId="queuePromo">
                <PromoQueue />
              </TabPane>
            </CardBody>
          </Card>
        </TabPane>

        <TabPane tabId="gameStats">
          <Card>
            <CardBody>
              <h4>Game Statistics</h4>
              <p>Game Statistics functionalities will be added here.</p>
            </CardBody>
          </Card>
        </TabPane>

        <TabPane tabId="logs">
          <Card>
            <CardBody>
              <h4>Logs</h4>
              <AdminLogs />
            </CardBody>
          </Card>
        </TabPane>

        <TabPane tabId="ratelist">
          <Card>
            <CardBody>
              <RateListManagement />
            </CardBody>
          </Card>
        </TabPane>
      </TabContent>
    </Container>
  );
};

export default AdminPanel;
